type selectionType = 'product' | 'service' | 'c_service';
import {
  SelectActionsEnum,
  SelectStatesEnum,
} from '@gid/models/dist/entities/job-selection';

const onPartialSelectionChange = (
  selections,
  payload,
  selectionType: selectionType,
) => {
  const { selected, item, state: itemState } = payload;
  const modifiedSelection = typeBasedObject(selectionType, payload);
  if (!selections.length) {
    selections.push(modifiedSelection);
  } else {
    const elementIndex = selections.findIndex(
      (selection) => selection[selectionType].toString() === item.toString(),
    );
    if (elementIndex === -1) {
      selections.push(modifiedSelection);
    } else {
      selections[elementIndex] = {
        ...selections[elementIndex],
        selected,
        state: itemState,
      };
    }
  }
  return selections;
};

const typeBasedObject = (type: selectionType, payload) => {
  let modifiedSelection = {
    selected: payload.selected,
    action: payload.action,
    state: payload.state,
    product: null,
    service: null,
    c_service: null,
  };
  switch (type) {
    case 'product':
      modifiedSelection.product = payload.item;
      break;
    case 'service':
      modifiedSelection.service = payload.item;
      break;
    case 'c_service':
      modifiedSelection.c_service = payload.item;
      break;
    default:
      console.log(`Sorry, type you provided is not a valid one`);
  }
  return modifiedSelection;
};

/** helper function used to load is current item selected on the page **/
const loadPartialSelection = (
  selections,
  actionType = SelectActionsEnum.PARTIAL_INVOICING,
) => {
  if (selections && selections.length) {
    const partialSelection = selections.filter(
      (select) => select.action === actionType,
    );
    return partialSelection[0]; // load first item from selections
  }
  return { selected: null, state: null };
};

/***
 * Mark all services on Job when product pacakge with services has been selected or unselected
 * **/
const markUnMarkLinkedServicesOnProduct = (
  serviceList: any,
  productId: string,
  jobId: string,
  selected: boolean,
) => {
  return serviceList.map((service) => {
    if (service.productId === productId) {
      const updatedSelections = onPartialSelectionChange(
        service.selections,
        {
          action: SelectActionsEnum.PARTIAL_INVOICING,
          item: service.id,
          jobId,
          selected: selected,
          serviceIndex: service.elementIndex,
          state: selected ? SelectStatesEnum.SCHEDULED : null,
        },
        'service',
      );
      return {
        ...service,
        selections: updatedSelections,
      };
    }
    return service;
  });
};

export {
  onPartialSelectionChange,
  loadPartialSelection,
  markUnMarkLinkedServicesOnProduct,
};
